module.exports = __webpack_public_path__ + "static/img/news2.777affe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news2/news2.jpg
// module id = 8ppk
// module chunks = 1